"use client";

import React, { useState } from "react";
import { CreditCard, Landmark, Smartphone, ShieldCheck, Lock, ArrowRight, Info } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const paymentMethods = [{
  id: "card",
  title: "Բանկային Քարտ",
  description: "Ապահով վճարում Visa կամ Mastercard քարտերով",
  icon: CreditCard
}, {
  id: "bank",
  title: "Բանկային Փոխանցում",
  description: "Ուղղակի փոխանցում հաշվեհամարին",
  icon: Landmark
}, {
  id: "wallet",
  title: "Էլեկտրոնային Դրամապանակ",
  description: "Արագ վճարում Apple կամ Google Pay-ով",
  icon: Smartphone
}];
export default function PaymentOptions() {
  const [selectedMethod, setSelectedMethod] = useState<string>("card");
  const [saveCard, setSaveCard] = useState<boolean>(true);
  const [autoPay, setAutoPay] = useState<boolean>(false);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const subtotal = 450000.00;
  const taxRate = 0.20;
  const tax = subtotal * taxRate;
  const total = subtotal + tax;
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('hy-AM', {
      style: 'currency',
      currency: 'AMD'
    }).format(amount);
  };
  return;
}